export default __webpack_public_path__ + "static/media/faq-illustrations.3abcf165.svg";